import { CancellationType } from 'types/Search/filter';

export const getSelected = (cancellation?: CancellationType): string[] => {
    const selected = [];
    if (cancellation === CancellationType.Cost) {
        selected.push(CancellationType.Cost);
    }
    if (cancellation === CancellationType.Free24Hour) {
        selected.push(CancellationType.Free24Hour);
    }

    return selected;
};
